import { SprayEventOperatorsIndex } from 'services/sprayEvents/types';

export enum TabName {
    OutsideRow = 'Outside Row',
    DoubleRow = 'Double Row'
}

export const OperatorFieldNames = {
    STANDARD: `sprayEventOperations[${SprayEventOperatorsIndex.STANDARD}]`,
    OUTSIDE: `sprayEventOperations[${SprayEventOperatorsIndex.OUTSIDE}]`,
    DOUBLE: `sprayEventOperations[${SprayEventOperatorsIndex.DOUBLE}]`,
    TWODIMENSION: `sprayEventOperations[${SprayEventOperatorsIndex.TWODIMENSION}]`
};
